import { useEffect, useState, useRef } from 'react'
import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { PaymentPageType, PaymentStatus } from '../../../../types/mf-execution.types'
import { useOrderPaymentStatusQuery } from '../../../../hooks/mf-execution/useOrderPaymentStatusQuery'
import { useNavigate } from 'react-router-dom'

export const BuyNetBankingLinkWaitingPage = () => {
  const [actionUrl, setActionUrl] = useState('')
  const [formMethod, setFormMethod] = useState('')
  const [parameters, setParameters] = useState<Record<string, string>>({})
  const formRef = useRef<HTMLFormElement>(null)

  const { paymentStatus, isError, isExpired } = useOrderPaymentStatusQuery({ maxTimer: 120000 })
  const navigate = useNavigate()

  const setNetBankingForm = ({
    actionUrl,
    parameters,
    formMethod
  }: {
    actionUrl: string
    parameters: Record<string, string>
    formMethod: string
  }) => {
    setActionUrl(actionUrl)
    setParameters(parameters)
    setFormMethod(formMethod)
  }

  useEffect(() => {
    if (
      isExpired ||
      isError ||
      paymentStatus?.status === PaymentStatus.FAILED ||
      (paymentStatus?.status === PaymentStatus.SUCCESS &&
        (!paymentStatus?.actionUrl || !paymentStatus?.parameters || !paymentStatus?.formMethod))
    ) {
      setTimeout(() => {
        navigate(`/${PaymentPageType.BUY}/payment-failed`)
      }, 2000)
    } else if (paymentStatus?.actionUrl && paymentStatus?.parameters && paymentStatus?.formMethod) {
      setNetBankingForm({
        actionUrl: paymentStatus?.actionUrl ?? '',
        parameters: paymentStatus?.parameters ?? {},
        formMethod: paymentStatus?.formMethod ?? ''
      })
    }
  }, [paymentStatus, isError, isExpired])

  useEffect(() => {
    if (actionUrl && parameters && formMethod && formRef.current) {
      // Auto-submit the form when both states are set
      setTimeout(() => {
        formRef.current?.submit()
      }, 2000)
    }
  }, [actionUrl, parameters, formMethod])

  return (
    <div>
      <form ref={formRef} method={formMethod} action={actionUrl} style={{ display: 'none' }}>
        {parameters &&
          Object.entries(parameters)?.map(([key, value]) => <input type='hidden' name={key} value={value} key={key} />)}
        <input type='submit' value='Test Bank Redirection' />
      </form>
      <div className='w-full h-screen flex flex-col items-center justify-center gap-5 bg-white py-8 px-5 '>
        <div className='flex justify-center items-center w-full'>
          <RenderHTML innerHTMLText={LoaderIcon} />
        </div>
        <div className='text-[#232323] text-[16px] font-[500] text-center max-w-[200px]'>
          Redirecting to Net banking
        </div>
      </div>
    </div>
  )
}

const LoaderIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
  <circle cx="24" cy="24" r="24" fill="#1470CC"/>
  <path d="M16.4934 32.3647L32.363 15.7697M32.363 15.7697L20.9268 16.3676M32.363 15.7697L32.8268 26.1676" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
